module.exports = __webpack_public_path__ + "img/logo-round.1d520138.png";